import { EventEmitter, Injectable, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {
  @Input() example: any
  result: any
  constructor(public dialog: MatDialog) { }
  @Output() disparadorCambiosService = new EventEmitter<string>();
  @Output() disparadorCambiosProvider = new EventEmitter<string>();
  @Output() disparadorCambios = new EventEmitter<string>();


  public getResult() {

    return this.result

  }

  public saveResult(a: any) {
    this.result = a
    console.log(this.result)


  }
  public saveResultService(a: any) {
    this.result = a
    console.log(this.result)


  }



  



}
